import { createSelector } from "reselect";
import { checkedDischargedOptionSelector } from "../checked_discharged_option_selector";

export const selectedDishcargeStateSelector = createSelector(
  checkedDischargedOptionSelector,
  checkedDischargedOption => {
    if (checkedDischargedOption.length) return checkedDischargedOption;
  }
);
